import styled from "styled-components";
import { useEffect, useRef } from 'react';

import {mq} from './util/media';

import SectionTitle from "./SectionTitle";
import SectionWrapper from "./SectionWrapper";
import GradientText from "./GradientText";
import Earn from "./EarnButton";
import Button from "./Button";
import Header from "./Header";

import { ReactComponent as HeaderLogo } from "../images/logo_hero.svg"

import anime from "animejs";
import { keyframes } from "styled-components";

const HeroSection = styled.div`
  ${mq.gt.md} {
    max-width: 1192px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
`

const HeroImageWrapper = styled.div`
  width: 100%;
  position: relative;
  isolation: isolate;
  aspect-ratio: 1;

  display: flex;
  justify-content: center;
  align-items: center;

  & svg {
    width: 100%;
    height: 100%;
  }

  & .logo {
    max-width: 150px;
    max-height: 150px;
    grid-area: logo;

    ${mq.gt.sm} {
      max-width: 350px;
      max-height: 361px;
    }
    
  }

  opacity: 0;
`

const GlowAnimation = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0.8;
  }

`

const HeroGlow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  z-index: -1;
  background: red;
  border-radius: 50%;
  background: radial-gradient(#C29554 0%, #C09353 10%, #754B3A 50%, transparent 70%);
  filter: blur(75px) brightness(1.2);
  transform: scale(1.1) scaleY(0.75);

  animation: ${GlowAnimation} 1.5s ease-in-out infinite alternate;
`

const ButtonWrapper = styled.div`
  display: flex;
  gap: 1.5rem;

  ${mq.lt.sm} {
    justify-content: center;
    gap: 1rem;
  }
`

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;


  ${mq.gt.xs} {

    display: grid;
    grid-template-columns: 1fr 1.33fr;
    gap: 2rem; 
    align-items: center;
    width: 100%;
  }

  ${mq.gt.sm} {
    gap: 62px;
  }



`

const InfoWrapper = styled.div`
  ${mq.gt.md} {
    margin: 48px 0 62px 0;
  }
  opacity: 0;
`

const HeaderFix = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

`


function Hero({loading, mainVideoRef}) {

  const heroText = useRef(null);
  const buttonRef = useRef(null);

  //check if video is fully loaded
  //NO MORE VIDEO NOW, SO WE DON'T REALLY NEED THIS
  var videoLoadCheck = setInterval(() => {
    if(loading === false) {
      if(mainVideoRef.current) {
        if (mainVideoRef.current !== null) {
          clearInterval(videoLoadCheck);
            anime({
              targets: `${HeroImageWrapper}`,
              opacity: [0 , 1],
              duration: 1000,
              easing: 'linear'
            }); 
   
        }
      }
    }
  }, 250);


  useEffect(() => {
    if(loading === false) {
      if(heroText.current && buttonRef.current) {
        if (document.visibilityState === "visible") {

          anime({
            targets: heroText.current,
            translateX: ['10%', '0%'],
            opacity: [0 , 1],
            duration: 1000,
            delay: 500,
            easing: 'easeInOutQuad'
          });
    
          anime({
            targets: buttonRef.current.children,
            translateY: ['10%', '0%'],
            opacity: [0 , 1],
            duration: 1000,
            delay: 800,
            easing: 'easeOutQuad'
          });

          anime({
            targets: mainVideoRef.current,
            translateY: ['5%', '-10%'],
            loop: true,
            direction: "alternate",
            easing: 'easeInOutQuad',
            duration: 4000,
          })
        } else {
          heroText.current.style.opacity = 1;
        }
      }
    }
  }, [loading, mainVideoRef]);

  return (
    <SectionWrapper type="regular">
      <HeaderFix>
        <Header loading={loading} />
        <HeroSection>
          <Inner>
            <HeroImageWrapper>
              <HeaderLogo ref={mainVideoRef} className="logo" />
              <HeroGlow />
            </HeroImageWrapper>
            <InfoWrapper ref={heroText} >
              <SectionTitle>
                Near Treasury<br/>
                First Decentralized <br/>
                <GradientText to="right" color1="#EC7BB8">3rd Gen. Savings</GradientText><br/>
                <GradientText to="right" color1="#EF8A96">Protocol</GradientText>
              </SectionTitle>
              <ButtonWrapper ref={buttonRef}>
                <Earn>Earn 23.97% APY</Earn>
                <Button link="/webapp" type='save'>Save Now</Button>
              </ButtonWrapper>
            </InfoWrapper>
          </Inner>
        </HeroSection>
      </HeaderFix>
    
    </SectionWrapper>
  )

}

export default Hero;